export const resolveWeightOnReferenceChange = (defaultWeight: number | null, isWeightDirty: boolean): number | null => {
    if (defaultWeight === null || isWeightDirty) {
        return null;
    }

    return defaultWeight;
};
